import React, { useMemo, useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowUp,
  faBookmark,
  faChevronDown,
  faCommentDots,
  faCompactDisc,
  faDesktop,
  faHeart,
  faHouse,
  faInbox,
  faMagnifyingGlass,
  faPlus,
  faPlay,
  faRotate,
  faShare,
  faStar,
  faUser,
  faUsers,
  faXmark,
} from '@fortawesome/free-solid-svg-icons';
import './App.css';
import DuoPage from './DuoPage';

const JEV_STATES = Object.freeze({
  KEEP: 'KEEP',
  SAVE: 'SAVE',
  SKIP: 'SKIP',
  HUMAN_REVIEW: 'HUMAN_REVIEW',
});

const videos = [
  {
    id: 'douyin-ai-coding-sun',
    url: require('./videos/douyin/douyin-ai-coding-sun.mp4'),
    sourceLabel: '抖音公开视频回放',
    sourceUrl: 'https://www.douyin.com/video/7585176612473556287',
    username: '@孙同学玩AI',
    title: '普通人用AI写代码，高手用它驯服AI',
    description: '普通人用AI写代码，高手用它驯服AI！ #AI编程 #程序员 #开源项目 #AI教程 #Vibecoding',
    song: '@孙同学玩AI创作的原声',
    likes: '3.9万', comments: 481, shares: 5489, saves: '4.4万', avatar: '孙',
    intent: '有用的技术内容',
    topComment: '怎么说呢，今年公司招了个人[捂脸]做东西但倒是挺快ai一顿整，结果叫他维护一个旧项目就抓耳捞腮，连引用类型、值类型都分不清，委托和事件作用域也不知道，很多基础知识极度匮乏，我个人感觉一个新人大量使用ai只会害了他。',
    sourceNote: '真实评论抓取自抖音公开视频页（2026-09-21），置顶为该页最高赞评论 616 赞',
    commentsData: [
      { user: '@逸风', text: '怎么说呢，今年公司招了个人[捂脸]做东西但倒是挺快ai一顿整，结果叫他维护一个旧项目就抓耳捞腮，连引用类型、值类型都分不清，委托和事件作用域也不知道，很多基础知识极度匮乏，我个人感觉一个新人大量使用ai只会害了他。', likes: '616' },
      { user: '@小电视', text: '虽然是史山，但是只要跑得起来，就让他堆呀。我让他写了一个程序，最开始几百行堆到上面七八千行，还往上堆，是吧？只要有问题就让他修复，修复好了，只要能正常运行就不用管他的', likes: '48' },
      { user: '@随风而行之', text: '作为小白试了几个月几款软件都是到最后改一个错误出现另一个错误的死循环之中。只能说相对于修图写代码这块还有巨大发展空间吧。', likes: '4' },
      { user: '@风', text: '我自己写的发卡网从零至一，从后端到前端，从最后的网页美化，目前项目已经完成99%，安全性测试和漏洞审查、支付这些都已经部署好了。Ai这种东西离不开人，我现在最烦的就是那叫人说什么问AI不就行了。', likes: '0' },
    ],
    decision: { action: JEV_STATES.SAVE, label: '收藏', confidence: 0.92, latency: 118, scores: { relevance: 0.95, sales: 0.06, repeat: 0.12 }, signals: ['评论区在讨论真实用人经验', '主题直接相关', '高赞评论信息量足'] },
  },
  {
    id: 'douyin-openspec-aiyuan',
    url: require('./videos/douyin/douyin-openspec-aiyuan.mp4'),
    sourceLabel: '抖音公开视频回放',
    sourceUrl: 'https://www.douyin.com/video/7562122574700842291',
    username: '@AI超元域',
    title: '让 AI 编程 100% 可控的 OpenSpec 教程',
    description: '程序员必看让AI编程100%可控！OpenSpec教程：让AI按规范写代码，支持Cursor、Claude Code、Codex！',
    song: '@AI超元域创作的原声',
    likes: 1407, comments: 35, shares: 333, saves: 1633, avatar: 'A',
    intent: '可执行的工具内容',
    topComment: '这是只能用英文讨论方案么？',
    sourceNote: '真实评论抓取自抖音公开视频页（2026-09-21），原片 11 分钟，demo 截取前 30 秒',
    commentsData: [
      { user: '@注册超麻烦', text: '这是只能用英文讨论方案么？', likes: '2' },
      { user: '@有超多尘锋', text: '这个视频质量真的好', likes: '1' },
      { user: '@王子文龙', text: '是不是可以把openspec的commands和skills迁移到claude的用户目录下呢，这样就可以全局使用了吧', likes: '0' },
      { user: '@影伴', text: '我们测试人员需要干嘛啊', likes: '0' },
      { user: '@那就换个昵称吧', text: '居然不支持Gemini', likes: '0' },
    ],
    decision: { action: JEV_STATES.KEEP, label: '继续看', confidence: 0.87, latency: 126, scores: { relevance: 0.93, sales: 0.09, repeat: 0.15 }, signals: ['有完整工作流演示', '评论在追问落地细节', '低营销感'] },
  },
  {
    id: 'douyin-deepseek-v4-compare',
    url: require('./videos/douyin/douyin-deepseek-v4-compare.mp4'),
    sourceLabel: '抖音公开视频回放',
    sourceUrl: 'https://www.douyin.com/video/7637165033952218387',
    username: '@臭爸屁AI实战',
    title: 'DeepSeek V4 VS 网页专家模式真实对比',
    description: 'deepseek V4 VS 网页专家模式 真实对比，兄弟们自己比比，智商差距有多少？ #deepseek #AI #编程 #开发',
    song: '明亮的一天',
    likes: 26, comments: 16, shares: 5, saves: 2, avatar: '臭',
    intent: '有争议的对比内容',
    topComment: '用免费网页版deepseek写代码做开发有什么弊端呢？',
    sourceNote: '真实评论抓取自抖音公开视频页（2026-09-21），原片 4.5 分钟，demo 截取前 30 秒',
    commentsData: [
      { user: '@一晖百映', text: '用免费网页版deepseek写代码做开发有什么弊端呢？', likes: '2' },
      { user: '@成宇²⁰¹⁹', text: '我找v4给我写APP代码和配置文件，然后打包过程给网页版给我改得面目全非[发怒]', likes: '1' },
      { user: '@凉风有幸', text: '什么硬件啊哥', likes: '1' },
      { user: '@BlaBla', text: 'V4pro 要花钱啊 你分析这版本下来多少钱', likes: '0' },
    ],
    decision: { action: JEV_STATES.HUMAN_REVIEW, label: '交给人判断', confidence: 0.55, latency: 134, scores: { relevance: 0.72, sales: 0.18, repeat: 0.34 }, signals: ['有真实对比但结论不明确', '评论在争论成本与硬件', '信号冲突'] },
  },
  {
    id: 'douyin-agent-learning',
    url: require('./videos/douyin/douyin-agent-learning.mp4'),
    sourceLabel: '抖音公开视频回放',
    sourceUrl: 'https://www.douyin.com/video/7686066359331081515',
    username: '@大模型开发教程',
    title: '我的 AI Agent 开发学习方法',
    description: '我的AI Agent开发学习方法，最简单、最实操的.. #人工智能 #ai #大模型 #程序员 #计算机',
    song: '@大模型开发教程创作的原声',
    likes: 70, comments: 4, shares: 6, saves: 47, avatar: '大',
    intent: '低信息密度内容',
    topComment: '求资料',
    sourceNote: '真实评论抓取自抖音公开视频页（2026-09-21），原片 69 秒，demo 截取前 30 秒',
    commentsData: [
      { user: '@南岛', text: '求资料', likes: '1' },
      { user: '@荣少.', text: '[666][666][666]', likes: '0' },
      { user: '@大模型开发教程', text: '溜 ai [来看我]', likes: '0' },
    ],
    decision: { action: JEV_STATES.SKIP, label: '跳过', confidence: 0.94, latency: 91, scores: { relevance: 0.41, sales: 0.22, repeat: 0.88 }, signals: ['评论只有“666”和“求资料”', '没有可验证步骤', '高重复风险'] },
  },
  {
    id: 'douyin-claude-unlimited',
    url: require('./videos/douyin/douyin-claude-unlimited.mp4'),
    sourceLabel: '抖音公开视频回放',
    sourceUrl: 'https://www.douyin.com/video/7684201286821265078',
    username: '@程序🦍',
    title: '用了 Claude 之后我的产出速度老板都害怕',
    description: '凡尔赛一下、自从我用了，Claude fable5.1无限续杯，我的产出速度我老板都害怕。#cursor #程序员 #编程 #代码',
    song: '@𝐆𝐍𝐀𝐑创作的原声',
    likes: 5, comments: 2, shares: 0, saves: 0, avatar: '程',
    intent: '疑似引流内容',
    topComment: '你的AI还失忆吗？开源项目，记忆桥 MemoryBridge：给 AI 一个跟着你走的记忆',
    sourceNote: '真实评论抓取自抖音公开视频页（2026-09-21），评论含引流内容',
    commentsData: [
      { user: '@无我无他', text: '你的AI还失忆吗？开源项目，记忆桥 MemoryBridge：给 AI 一个跟着你走的记忆，GitHub：https://github.com/jiabaobei/memory-bridge ⭐ 觉得有用请点个 Star', likes: '0' },
      { user: '@程序🦍', text: '[群聊] 群146852', likes: '0' },
    ],
    decision: { action: JEV_STATES.SKIP, label: '跳过', confidence: 0.93, latency: 96, scores: { relevance: 0.46, sales: 0.61, repeat: 0.72 }, signals: ['评论区是引流广告', '只有气势没有方法', '营销感高'] },
  },
];

const actionColors = { [JEV_STATES.SAVE]: 'violet', [JEV_STATES.KEEP]: 'green', [JEV_STATES.SKIP]: 'red', [JEV_STATES.HUMAN_REVIEW]: 'amber' };
const JEV_PROXY_URL = process.env.REACT_APP_JEV_PROXY_URL ?? '';

function SingleFeedPage() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [commentsOpen, setCommentsOpen] = useState(false);
  const [isThinking, setIsThinking] = useState(false);
  const [autoRun, setAutoRun] = useState(false);
  const [savedIds, setSavedIds] = useState([]);
  const [likedIds, setLikedIds] = useState([]);
  const [isPlaying, setIsPlaying] = useState(true);
  const [showHeart, setShowHeart] = useState(false);
  const [decisionLog, setDecisionLog] = useState([]);
  const [liveDecisions, setLiveDecisions] = useState({});
  const [apiStatus, setApiStatus] = useState('fixture');
  const [apiError, setApiError] = useState('');
  const videoRef = useRef(null);
  const gestureRef = useRef(null);
  const suppressClickRef = useRef(false);
  const clickTimerRef = useRef(null);
  const heartTimerRef = useRef(null);
  const wheelLockRef = useRef(false);
  const currentVideo = videos[currentIndex];
  const displayedDecision = liveDecisions[currentVideo.id] || currentVideo.decision;

  const stats = useMemo(() => ({
    scanned: decisionLog.length,
    skipped: decisionLog.filter((item) => item.action === JEV_STATES.SKIP).length,
    saved: savedIds.length,
    human: decisionLog.filter((item) => item.action === JEV_STATES.HUMAN_REVIEW).length,
  }), [decisionLog, savedIds]);

  const runDecision = async () => {
    if (isThinking) return;
    setIsThinking(true);
    setApiStatus('thinking');
    setApiError('');
    try {
      const response = await fetch(`${JEV_PROXY_URL}/api/jev/decide`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          title: currentVideo.title,
          description: currentVideo.description,
          username: currentVideo.username,
          topComment: currentVideo.topComment,
          comments: currentVideo.commentsData,
        }),
      });
      const payload = await response.json();
      if (!response.ok) throw new Error(payload.error || `Jev proxy returned HTTP ${response.status}`);
      const decision = {
        ...payload.decision,
        latency: payload.latency_ms,
        scores: currentVideo.decision.scores,
        source: 'live',
      };
      setLiveDecisions((items) => ({ ...items, [currentVideo.id]: decision }));
      const logItem = { id: `${currentVideo.id}-${Date.now()}`, title: currentVideo.title, action: decision.action, label: decision.label, confidence: decision.confidence, latency: decision.latency };
      setDecisionLog((items) => [logItem, ...items].slice(0, 7));
      setApiStatus('live');
      setIsThinking(false);
      if (decision.action === JEV_STATES.SAVE) setSavedIds((items) => (items.includes(currentVideo.id) ? items : [...items, currentVideo.id]));
      if (autoRun && decision.action !== JEV_STATES.HUMAN_REVIEW) window.setTimeout(() => moveVideo(1), 650);
    } catch (error) {
      setApiStatus('error');
      setApiError(error.message);
      setIsThinking(false);
    }
  };

  const moveVideo = (direction) => {
    setCommentsOpen(false);
    setIsPlaying(true);
    setCurrentIndex((index) => (index + direction + videos.length) % videos.length);
  };

  const setPlayback = (playing) => {
    const video = videoRef.current;
    if (video) {
      if (playing) video.play().catch(() => {});
      else video.pause();
    }
    setIsPlaying(playing);
  };

  const togglePlayback = () => setPlayback(!isPlaying);

  const showLikeBurst = () => {
    setShowHeart(true);
    window.clearTimeout(heartTimerRef.current);
    heartTimerRef.current = window.setTimeout(() => setShowHeart(false), 620);
  };

  const likeVideo = () => {
    setLikedIds((items) => (items.includes(currentVideo.id) ? items : [...items, currentVideo.id]));
    showLikeBurst();
  };

  const handleStagePointerDown = (event) => {
    if (event.target.closest('button')) return;
    gestureRef.current = { x: event.clientX, y: event.clientY, time: Date.now() };
    event.currentTarget.setPointerCapture?.(event.pointerId);
  };

  const handleStagePointerUp = (event) => {
    if (!gestureRef.current || event.target.closest('button')) return;
    const start = gestureRef.current;
    const deltaX = event.clientX - start.x;
    const deltaY = event.clientY - start.y;
    const distance = Math.hypot(deltaX, deltaY);
    gestureRef.current = null;
    event.currentTarget.releasePointerCapture?.(event.pointerId);
    if (distance < 55 || Math.abs(deltaY) < Math.abs(deltaX) * 1.15) return;
    event.preventDefault();
    suppressClickRef.current = true;
    window.setTimeout(() => { suppressClickRef.current = false; }, 300);
    clickTimerRef.current && window.clearTimeout(clickTimerRef.current);
    if (deltaY < 0) moveVideo(1);
    else moveVideo(-1);
    const stage = event.currentTarget;
    stage.classList.remove('gesture-next', 'gesture-prev');
    stage.classList.add(deltaY < 0 ? 'gesture-next' : 'gesture-prev');
    window.setTimeout(() => stage.classList.remove('gesture-next', 'gesture-prev'), 240);
  };

  const handleStageClick = (event) => {
    if (event.target.closest('button')) return;
    if (suppressClickRef.current) return;
    if (gestureRef.current) return;
    window.clearTimeout(clickTimerRef.current);
    clickTimerRef.current = window.setTimeout(() => togglePlayback(), 220);
  };

  const handleStageDoubleClick = (event) => {
    if (event.target.closest('button')) return;
    window.clearTimeout(clickTimerRef.current);
    likeVideo();
  };

  const handleStageWheel = (event) => {
    if (Math.abs(event.deltaY) < 22 || wheelLockRef.current) return;
    event.preventDefault();
    wheelLockRef.current = true;
    moveVideo(event.deltaY > 0 ? 1 : -1);
    window.setTimeout(() => { wheelLockRef.current = false; }, 420);
  };

  const toggleSaved = () => setSavedIds((items) => items.includes(currentVideo.id) ? items.filter((id) => id !== currentVideo.id) : [...items, currentVideo.id]);

  return (
    <main className="demo-shell">
      <header className="demo-header">
        <div>
          <div className="eyebrow"><FontAwesomeIcon icon={faStar} /> JEVTOK / DECISION FEED</div>
          <h1>让 Jev 替你刷短视频</h1>
          <p>普通大模型负责解释，Jev 负责下一步：继续看、收藏、跳过，或者承认自己不确定。</p>
        </div>
        <div className="mission-card"><span>你的任务</span><strong>找真正有用的 AI / 编程内容</strong><small>不要营销号 · 不要鸡汤 · 不要重复内容</small></div>
      </header>

      <section className="demo-grid">
        <section className="phone-stage" aria-label="模拟短视频 feed">
          <div className="phone-frame">
            <div className="phone-speaker" />
            <div className="phone-screen">
              <div className="feed-topbar"><span className="feed-desktop-icon"><FontAwesomeIcon icon={faDesktop} /></span><span>Following&nbsp;&nbsp; <b>For You</b></span><span className="feed-search-icon"><FontAwesomeIcon icon={faMagnifyingGlass} /></span></div>
              <div className="video-stage" onPointerDown={handleStagePointerDown} onPointerUp={handleStagePointerUp} onPointerCancel={() => { gestureRef.current = null; }} onClick={handleStageClick} onDoubleClick={handleStageDoubleClick} onWheel={handleStageWheel}>
                <video key={currentVideo.id} ref={videoRef} className="active-video" src={currentVideo.url} autoPlay={isPlaying} muted loop playsInline />
                <div className="video-vignette" />
                <div className={`heart-burst ${showHeart ? 'show' : ''}`} aria-hidden="true"><FontAwesomeIcon icon={faHeart} /></div>
                <div className="video-meta"><strong>{currentVideo.username}</strong><h2>{currentVideo.title}</h2><p>{currentVideo.description}</p><span className="music-line">♫ {currentVideo.song}</span></div>
                <div className="video-actions">
                  <div className="creator-action"><div className="creator-avatar">{currentVideo.avatar}</div><button type="button" className="follow-plus" aria-label="关注"><FontAwesomeIcon icon={faPlus} /></button></div>
                  <button type="button" className={likedIds.includes(currentVideo.id) ? 'is-liked' : ''} onClick={likeVideo} aria-label="点赞"><FontAwesomeIcon icon={faHeart} /><small>{currentVideo.likes}</small></button>
                  <button type="button" onClick={() => setCommentsOpen(true)} aria-label="评论"><FontAwesomeIcon icon={faCommentDots} /><small>{currentVideo.comments}</small></button>
                  <button type="button" className={savedIds.includes(currentVideo.id) ? 'is-saved' : ''} onClick={toggleSaved} aria-label="收藏"><FontAwesomeIcon icon={faBookmark} /><small>{currentVideo.saves}</small></button>
                  <button type="button" aria-label="分享"><FontAwesomeIcon icon={faShare} /><small>{currentVideo.shares}</small></button>
                  <div className="music-disc"><FontAwesomeIcon icon={faCompactDisc} /></div>
                </div>
              </div>
              <div className="feed-bottom"><span className="feed-tab active"><FontAwesomeIcon icon={faHouse} /><small>Home</small></span><span className="feed-tab"><FontAwesomeIcon icon={faUsers} /><small>Friends</small></span><span className="create-button"><FontAwesomeIcon icon={faPlus} /></span><span className="feed-tab"><FontAwesomeIcon icon={faInbox} /><small>Inbox</small></span><span className="feed-tab"><FontAwesomeIcon icon={faUser} /><small>Profile</small></span></div>
              <div className="feed-arrows"><button type="button" onClick={() => moveVideo(-1)} aria-label="上一条"><FontAwesomeIcon icon={faChevronDown} rotation={180} /></button><button type="button" onClick={() => moveVideo(1)} aria-label="下一条"><FontAwesomeIcon icon={faChevronDown} /></button></div>
              {commentsOpen && <CommentsDrawer video={currentVideo} onClose={() => setCommentsOpen(false)} />}
            </div>
          </div>
          <div className="phone-caption">PUBLIC FEED SIMULATION · LOCAL LOOP</div>
        </section>

        <aside className="jev-panel">
          <div className="panel-heading"><div><span className="status-dot" /> JEV DECISION CONSOLE</div><span className={`replay-tag ${apiStatus === 'live' ? 'live' : ''}`}>{apiStatus === 'live' ? 'LIVE JEV' : apiStatus === 'thinking' ? 'CALLING API' : 'FIXTURE FALLBACK'}</span></div>
          <div className="current-signal"><div className="signal-label"><span>正在读取</span><span>VIDEO {String(currentIndex + 1).padStart(2, '0')} / {String(videos.length).padStart(2, '0')}</span></div><strong>{currentVideo.title}</strong><span className="source-badge">{currentVideo.sourceLabel || '本地素材回放'}</span><p className="top-comment"><FontAwesomeIcon icon={faCommentDots} /> 最高赞评论（演示）：{currentVideo.topComment}</p><button type="button" className="comment-link" onClick={() => setCommentsOpen(true)}>打开评论区 <FontAwesomeIcon icon={faArrowUp} rotation={45} /></button></div>
          <div className="decision-card"><div className="decision-card-top"><span>JEV OUTPUT STATE</span><span>{isThinking ? 'THINKING…' : `${displayedDecision.latency} ms`}</span></div><div className={`decision-main ${isThinking ? 'thinking' : actionColors[displayedDecision.action]}`}><strong>{isThinking ? '读取评论信号…' : displayedDecision.label}</strong><span>{isThinking ? 'OBSERVE → EVALUATE' : `${displayedDecision.action} · ${Math.round(displayedDecision.confidence * 100)}%`}</span></div><div className="state-path"><span>OBSERVE</span><i>→</i><span>EVALUATE</span><i>→</i><b>DECIDE</b><i>→</i><span>EXECUTE</span></div><div className="score-grid"><Score label="相关性" value={displayedDecision.scores.relevance} /><Score label="营销感" value={displayedDecision.scores.sales} inverted /><Score label="重复风险" value={displayedDecision.scores.repeat} inverted /></div><div className="signal-chips">{displayedDecision.signals.map((signal) => <span key={signal}>{signal}</span>)}</div>{displayedDecision.probabilities && <ProbabilityStrip probabilities={displayedDecision.probabilities} />}</div>
          <div className="control-row"><button type="button" className="run-button" onClick={runDecision} disabled={isThinking}><FontAwesomeIcon icon={isThinking ? faRotate : faPlay} spin={isThinking} /> {isThinking ? 'Jev 正在判断' : '让 Jev 决定'}</button><button type="button" className={`auto-button ${autoRun ? 'active' : ''}`} onClick={() => setAutoRun((value) => !value)}>{autoRun ? '自动刷：开' : '自动刷：关'}</button></div>
          {apiStatus === 'live' && <div className="api-note live-note">已收到 Jev 实时判断 · key 只在本地代理使用</div>}
          {apiStatus === 'error' && <div className="api-note error-note">实时 API 暂不可用，当前仍显示 fixture：{apiError}</div>}
          <div className="stats-row"><Stat value={stats.scanned} label="已判断" /><Stat value={stats.skipped} label="已跳过" /><Stat value={stats.saved} label="已收藏" /><Stat value={stats.human} label="交给人" /></div>
          <div className="decision-log"><div className="log-heading"><span>DECISION STREAM</span><span>LIVE</span></div>{decisionLog.length === 0 && <div className="empty-log">点击“让 Jev 决定”，看它替你执行下一步。</div>}{decisionLog.map((item) => <div className="log-item" key={item.id}><span className={`log-dot ${actionColors[item.action]}`} /><div><strong>{item.label}</strong><small>{item.title}</small></div><b>{Math.round(item.confidence * 100)}%</b></div>)}</div>
        </aside>
      </section>
    </main>
  );
}

function App() {
  const route = window.location.pathname.replace(/\/+$/, '') || '/';
  return route === '/duo' ? <DuoPage videos={videos} /> : <SingleFeedPage />;
}

function Score({ label, value, inverted = false }) {
  const display = inverted ? 1 - value : value;
  return <div className="score-item"><div><span>{label}</span><b>{Math.round(display * 100)}</b></div><div className="score-track"><i style={{ width: `${display * 100}%` }} /></div></div>;
}

function ProbabilityStrip({ probabilities }) {
  return <div className="live-probabilities"><span>LIVE PROBABILITY</span>{[JEV_STATES.KEEP, JEV_STATES.SAVE, JEV_STATES.SKIP, JEV_STATES.HUMAN_REVIEW].map((state) => <b key={state}>{state}<em>{Math.round(Number(probabilities[state] || 0) * 100)}%</em></b>)}</div>;
}

function Stat({ value, label }) {
  return <div><strong>{value}</strong><span>{label}</span></div>;
}

function CommentsDrawer({ video, onClose }) {
  return <div className="comments-backdrop" onClick={onClose}><section className="comments-drawer" onClick={(event) => event.stopPropagation()}><div className="drawer-handle" /><div className="drawer-header"><strong>评论 {video.comments}</strong><button type="button" onClick={onClose} aria-label="关闭评论"><FontAwesomeIcon icon={faXmark} /></button></div><div className="drawer-tabs"><span className="active">全部</span><span>最热</span></div><div className="drawer-note">{video.commentStatus || 'Jev 读取最高赞评论，并把评论区当成视频的第二层语境。'}</div><div className="comment-list">{video.commentsData.map((comment, index) => <div className={`comment-row ${index === 0 ? 'top-comment-row' : ''}`} key={`${comment.user}-${comment.text}`}><div className="comment-avatar">{comment.user.slice(1, 2).toUpperCase()}</div><div className="comment-content"><div className="comment-user-row"><strong>{comment.user}</strong><small>{index === 0 ? '刚刚' : '1小时前'}</small></div><p>{comment.text}</p><div className="comment-meta"><span>{index === 0 && <em>最高赞样本</em>} 回复</span><button type="button" aria-label="赞评论"><FontAwesomeIcon icon={faHeart} /> {comment.likes}</button></div></div></div>)}</div><div className="drawer-composer"><span>添加评论...</span><small>☺</small><small>♡</small><FontAwesomeIcon icon={faArrowUp} rotation={45} /></div></section></div>;
}

export default App;
